import { render, staticRenderFns } from "./UserColleagueCard.vue?vue&type=template&id=2bb7c744"
import script from "./UserColleagueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UserColleagueCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports